import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";
import { ProfileItem } from "../interfaces/Profile";
import { ProfilesResponse } from "../slices/userProfiles/types";

const api = new APIClient();

/**
 * Get all profiles (Super Admin) - DEPRECATED
 * NOTE: Super Admin profiles page will never be implemented
 * This method is kept for backward compatibility but should not be used
 * Use getTenantProfiles() or getClientProfiles() instead
 */
export const getAllProfiles = (
    pageNumber: number = 1,
    pageSize: number = 50
): Promise<ProfilesResponse> => {
    console.warn("getAllProfiles is deprecated - Super Admin profiles page will never be implemented. Use getTenantProfiles() or getClientProfiles() instead.");
    // Real API call with query parameters
    return api.get(url.GET_PROFILES, {
        pageNumber,
        pageSize,
    }) as unknown as Promise<ProfilesResponse>;
};

/**
 * Get Tenant profiles - used when creating tenant users/roles
 * No parameters required per API documentation
 * Calls: GET /api/v1/Profile/Tenant
 */
export const getTenantProfiles = (): Promise<ProfilesResponse> => {
    // Explicitly pass undefined to ensure no query parameters are added
    // This calls /api/v1/Profile/Tenant (no query params)
    if (process.env.NODE_ENV === 'development') {
        console.log("🟢 Fetching Tenant Profiles from:", url.GET_TENANT_PROFILES);
    }
    return api.get(url.GET_TENANT_PROFILES, undefined) as unknown as Promise<ProfilesResponse>;
};

/**
 * Get Client profiles - used when creating client users
 * No parameters required per API documentation
 */
export const getClientProfiles = (): Promise<ProfilesResponse> => {
    // Explicitly pass undefined to ensure no query parameters are added
    return api.get(url.GET_CLIENT_PROFILES, undefined) as unknown as Promise<ProfilesResponse>;
};

export const createProfile = (data: Partial<ProfileItem>): Promise<ProfileItem> => {
    
    return api.create(url.POST_PROFILE, data) as unknown as Promise<ProfileItem>;
};

export const updateProfile = (
    id: string,
    data: Partial<ProfileItem>
): Promise<ProfileItem> => {
    
    return api.put(url.PUT_PROFILE + "/" + id, data) as unknown as Promise<ProfileItem>;
};

export const deleteProfile = (id: string): Promise<void> => {
    
    return api.delete(url.DELETE_PROFILE + "/" + id) as unknown as Promise<void>;
};